/**
 * Converts an ISO 8601 duration string (e.g., P30D, P1M, P1Y, P2M15D)
 * into a human-readable format (e.g., "30 Days", "1 Month", "1 Year", "2 Months 15 Days").
 */
export const formatIsoDuration = (
  duration: string | undefined,
): string | undefined => {
  if (!duration) return undefined;

  const match = duration.match(/^P(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)D)?$/);
  if (!match) return duration; // Return as-is if not a recognized ISO duration

  const years = match[1] ? parseInt(match[1]) : 0;
  const months = match[2] ? parseInt(match[2]) : 0;
  const days = match[3] ? parseInt(match[3]) : 0;

  const parts: string[] = [];
  if (years) parts.push(`${years} ${years === 1 ? "Year" : "Years"}`);
  if (months) parts.push(`${months} ${months === 1 ? "Month" : "Months"}`);
  if (days) parts.push(`${days} ${days === 1 ? "Day" : "Days"}`);

  return parts.length > 0 ? parts.join(" ") : duration;
};
